import {
  createAction,
  joinActions,
  props,
} from "../../helpers/store/actions-helpers";
import {
  SupportChatAppearance,
  SupportConversation,
  SupportMessage,
  SupportOnlineAgent,
  SupportVisitor,
} from "../interfaces/types";

export const setSupportConfigAction = createAction(
  "[WembiiSupport] Set Config",
  props<{ config: SupportChatAppearance }>()
);

export const setSelectedSupportConversationAction = createAction(
  "[WembiiSupport] Select Conversation",
  props<{ id: string | null }>()
);

export const setSupportConversationsAction = createAction(
  "[WembiiSupport] Set Conversations",
  props<{ conversations: SupportConversation[] }>()
);

export const upsertSupportConversationAction = createAction(
  "[WembiiSupport] Upsert Conversation",
  props<{ conversation: SupportConversation }>()
);

export const setSupportMessagesAction = createAction(
  "[WembiiSupport] Set Messages",
  props<{ messages: SupportMessage[] }>()
);

export const addSupportMessageAction = createAction(
  "[WembiiSupport] Add Message",
  props<{ message: SupportMessage; conversationId: string }>()
);

export const setSupportVisitorsAction = createAction(
  "[WembiiSupport] Set Visitors",
  props<{ visitors: SupportVisitor[] }>()
);

export const upsertSupportVisitorAction = createAction(
  "[WembiiSupport] Upsert Visitor",
  props<{ visitor: SupportVisitor }>()
);

export const removeSupportVisitorAction = createAction(
  "[WembiiSupport] Remove Visitor",
  props<{ id: string }>()
);

export const setWidgetSessionAction = createAction(
  "[WembiiSupport] Set Widget Session",
  props<{
    conversationId: string | null;
    room: string | null;
  }>()
);

export const setSupportOnlineAgentsAction = createAction(
  "[WembiiSupport] Set Online Agents",
  props<{ agents: SupportOnlineAgent[] }>()
);

export const setSupportAgentSocketSubscriptionAction = createAction(
  "[WembiiSupport] Set Agent Socket Subscription",
  props<{
    userId?: string;
    conversationId?: string;
    room?: string;
  }>()
);

const actions = joinActions({
  setSupportConfigAction,
  setSelectedSupportConversationAction,
  setSupportConversationsAction,
  upsertSupportConversationAction,
  setSupportMessagesAction,
  addSupportMessageAction,
  setSupportVisitorsAction,
  upsertSupportVisitorAction,
  removeSupportVisitorAction,
  setWidgetSessionAction,
  setSupportOnlineAgentsAction,
  setSupportAgentSocketSubscriptionAction,
});

export type WembiiSupportAction = typeof actions;
